import React, { memo } from 'react'
import { Handle, Position, type NodeProps } from 'reactflow'
import { nodeCardClass, nodeChipClass, nodeHandleClass, nodeIcon, nodeTextClass } from '../../nodeCatalog'

const TYPE = 'rateLimit'
const Icon = nodeIcon(TYPE)

const RateLimitNode: React.FC<NodeProps> = ({ data, selected }) => {
  const config = data.rate_limit_config
  let subtitle = 'no limit set'

  if (config?.mode === 'daily_cap') {
    subtitle = `${config.max_per_day || 0}/day`
  } else if (config?.mode === 'hourly_cap') {
    subtitle = `${config.max_per_hour || 0}/hr`
  } else if (config?.mode === 'random_delay') {
    subtitle = `${config.min_delay_minutes || 0}-${config.max_delay_minutes || 0} min delay`
  }

  return (
    <div className={nodeCardClass(TYPE, selected)}>
      <Handle type="target" position={Position.Top} className={nodeHandleClass(TYPE)} />
      <div className="flex items-center gap-2">
        <div className={nodeChipClass(TYPE)}>
          <Icon className={`w-4 h-4 ${nodeTextClass(TYPE)}`} />
        </div>
        <div className="flex-1 min-w-0">
          <p className={`text-[10px] font-emphasis uppercase tracking-wider ${nodeTextClass(TYPE)}`}>Rate Limit</p>
          <p className="text-sm font-medium text-foreground truncate">{data.label || 'Rate Limit'}</p>
        </div>
      </div>
      <p className="mt-1 text-xs text-muted-foreground pl-10 capitalize">{subtitle}</p>
      <Handle type="source" position={Position.Bottom} className={nodeHandleClass(TYPE)} />
    </div>
  )
}

export default memo(RateLimitNode)
